import { Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import MenuItem from "@mui/material/MenuItem";

import MySelectField from "components/Inputs/MySelectField";

const VehicleFuelTypeSelect = (props) => {
  const { t } = useTranslation();
  const { enums, value, updateValues } = props;

  const [vehicleFuelTypes, setVehicleFuelTypes] = useState();

  useEffect(() => {
    if (enums) {
      setVehicleFuelTypes(enums?.data?.vehicles?.car?.fuel_type);
    }
  }, [enums]);

  const handleSelectChange = ({ target }) => {
    updateValues({ [target.name]: target.value });
  };

  return (
    <Fragment>
      <MySelectField
        id="select_order_type"
        name="fuel_type"
        value={value ? value : 0}
        onChange={handleSelectChange}
      >
        {vehicleFuelTypes
          ? vehicleFuelTypes.map((option) => (
              <MenuItem key={option.key} value={option.key}>
                {t(option.value)}
              </MenuItem>
            ))
          : null}
      </MySelectField>
    </Fragment>
  );
};

export default VehicleFuelTypeSelect;
